import { TaskType, TaskModalComponent } from './taskModal.types';
import EmailTaskModal from './EmailTaskModal';
import MissingEmailTaskModal from './MissingEmailTaskModal';

/**
 * Registry mapping each TaskType to its modal component.
 * To add a new task type: add the enum value in taskModal.types.ts,
 * create a new modal component, and register it here.
 */
const taskModalRegistry: Record<TaskType, TaskModalComponent> = {
  [TaskType.EmailTask]: EmailTaskModal,
  [TaskType.MissingEmailTask]: MissingEmailTaskModal,
};

export default taskModalRegistry;
